export default __webpack_public_path__ + "static/media/frequency_blue.7f0a34d5.png";